import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import QRImage from "../../assets/images/whatsappQR.png";
import Scucces from "../../assets/images/scucces.png";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const [paymentData, setPaymentData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve payment data from localStorage
    const storedData = localStorage.getItem("paymentDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        console.log("Payment Data:", parsedData); // Debugging log
        setPaymentData(parsedData);
      } catch (error) {
        console.error("Error parsing payment data:", error);
      }
    }

    // Clear localStorage when user navigates back
    const handlePopState = () => {
      localStorage.removeItem("paymentDetails");
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const handleGoBack = () => {
    localStorage.removeItem("paymentDetails");
    navigate("/");
  };

  return (
    <div className="payment-success container">
      {/* Success Image */}
      <div className="qr-section success-image">
        <img src={Scucces} alt="Payment Success" className="qr-image" />
      </div>

      {/* QR Code & Payment Details Section */}
      <div className="content-wrapper">
        {/* QR Image (Left) */}
        <div className="qr-section qr-left">
          <img src={QRImage} alt="QR Code" className="qr-image" />
        </div>

        {/* Payment Details (Right) */}
        <div className="details-section">
          <h2 className="success-title">Payment Successful</h2>
          <p className="success-message">
            Thank you for your payment,{" "}
            {paymentData?.campaign_data?.first_name ?? "Guest"}{" "}
            {paymentData?.campaign_data?.last_name ?? ""}.
          </p>

          {paymentData ? (
            <div className="payment-details">
              {paymentData.payment_details ? (
                <>
                  <p>
                    <strong>Amount Paid:</strong> ₹
                    {paymentData.payment_details.amount ?? "N/A"}
                  </p>
                  <p>
                    <strong>Transaction ID:</strong>{" "}
                    {paymentData.payment_details.payment_id ?? "N/A"}
                  </p>
                  <p>
                    <strong>Order ID:</strong>{" "}
                    {paymentData.payment_details.order_id ?? "N/A"}
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    {paymentData.campaign_data?.email ?? "N/A"}
                  </p>
                  <p>
                    <strong>Phone:</strong>{" "}
                    {paymentData.campaign_data?.phone ?? "N/A"}
                  </p>
                </>
              ) : (
                <p>No payment details found.</p>
              )}
            </div>
          ) : (
            <p>Loading payment details...</p>
          )}

          {/* Go Back Button */}
          <button className="go-back-btn" onClick={handleGoBack}>
            Go Back
          </button>
          <button className="btnJoinWhatsapp"><a href="https://chat.whatsapp.com/IYK93IcOPOWEmrDS9La7Rc">Join WhatsApp</a></button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
